import React from 'react';

import './RadioGroup.scss';

const RadioButton = ({ name, id, value, onClick, checked, label, disabled, ...rest }) => {
  return (
    <div className='custom-radio_wrapper'>
      <input
        className='custom-radio_input'
        type='radio'
        name={name}
        id={id}
        value={value}
        onClick={onClick}
        onChange={() => null}
        checked={checked}
        disabled={disabled}
        {...rest}
      />
      <label className='custom-radio_button' htmlFor={id} disabled={disabled}>
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
